import React, {useState,useEffect} from 'react';
import ic_plus from 'image/ic_down.svg';
import {Empty} from 'components/items';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
const db = firebase.firestore();
const COLLECTION = 'customer_faq';

const FAQ = () => {
  const [nowLnb, setNowLnb] = useState();
  const [list_faq, setListFaq] = useState([]);
  const [data, setData] = useState([]);
  const [resultFaq, setResultFaq] = useState([]);
  const [nowId, setNowId] = useState('');
  const [isMobile, setIsMobile] = useState(false);
    
  useEffect(()=> {
    const init = async () => {
      const data_temp = await _get();
      setData(data_temp);

      const data_category = await _getCategory();
      setListFaq(data_category);
      setNowLnb(data_category[0])
    }
    init();

    checkWindowWidth();
    window.addEventListener('resize', checkWindowWidth)
  },[])

  const checkWindowWidth = () => {
    if(window.innerWidth<768){
      setIsMobile(true);
    }else{
      setIsMobile(false);
    }
  }

  const _get = async () => {
    const getData = await db.collection(COLLECTION).get();
    const result =  getData.docs.filter(el => {
      return el.id !== 'category'
    })

    return result.map(el => {
      return {
        ...el.data(),
        id: el.id 
      }
    })
  }

  const _getCategory = async () => {
    const getCategory = await db.collection(COLLECTION).doc('category').get();
    const result = getCategory.data().data;
    return result;
  }

  useEffect(()=> {
    setResultFaq(data.filter(el=> {
      return el.category === nowLnb
    }))
  },[nowLnb, data])

  const handleLnbClicked = (e) => {
    setNowLnb(e.target.innerHTML);
  }

  const handleListClick = (id) => {
    if(id === nowId){
      setNowId('');
    }else{
      setNowId(id)
    }
  }

  const drawQnaList = () => {
    if(!isMobile){

      return drawListPc()
    }else{

      return drawListMobile()
    }
  }

  const drawListPc = () => {
    return  <div className="wrap-faq">
              <div className="wrap-list left">
                {resultFaq.map((el,index) => {
                  if(index%2){
                    return ''
                  }
                  return <List key = {index} el = {el} nowId = {nowId} index = {index} handleListClick = {handleListClick}/>
                })}
              </div>

              <div className="wrap-list right">
                {resultFaq.map((el,index) => {
                  if(index%2===0){
                    return ''
                  }
                  return <List key = {index} el = {el} nowId = {nowId} index = {index} handleListClick = {handleListClick}/>
                })}
              </div>
            </div>
  }

  const drawListMobile = () => {
    return <div className="wrap-faq">
    <div className="wrap-list full">
      {resultFaq.map((el,index) => {
        return <List key = {index} el = {el} nowId = {nowId} index = {index} handleListClick = {handleListClick}/>
      })}
    </div>
  </div>
  }

  return (
    <section className="FAQ">
      <div className="con">
        <h3 className="section-title">FAQ</h3>
        <div className="wrap-lnb">
          <ul className="lnb-faq">
            {list_faq.map((el,index) => {
              return <li  className={nowLnb===el ? `active` : ""} onClick={handleLnbClicked} key={index}>{el}</li>
            })}
          </ul>
        </div>

        <div className="wrap-inner">
          {resultFaq[0]
          ? drawQnaList()
          : <Empty text = "준비 중 입니다. "/>}

        </div>
      </div>
      
    </section>
  );
}

const List = ({el, nowId, handleListClick, index}) => {
  return  <li className={`list-faq ${nowId===el.id ? 'active' : ''}`} key = {el.id} onClick={() => {handleListClick(el.id)}}>
            <div className="wrap-title">
              <p className='title'>0{index+1}. {el.title}</p>
              <img src={ ic_plus} alt="pluse"/>
            </div>

            <div className="wrap-contents">
              <div>
                <p className="category color-main">#{el.category}</p>
                <p className='text'>{el.text}</p>
              </div>
            </div>
          </li>
}

export default FAQ;